import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { paragraphMedium, paragraphSmall } from '@helpers/typography';
import styled from 'styled-components';
import { BackButtonIconStyles, BackButtonStyles } from '../LocationMap.styles';
const Container = styled.div `
  display: flex;
  flex-direction: column;
  background: ${brand.beige};
  height: 100%;

  @media ${until(Device.TabletLarge)} {
    margin-left: calc(var(--sitePadding) * -1);
    margin-right: calc(var(--sitePadding) * -1);
  }
`;
const ImageWrapper = styled.div `
  ${imageWrapperPreserveRatio(258, 171)};

  background: ${brand.white};
`;
const Image = styled.img `
  ${imageCoverContainer()};

  object-fit: contain;
`;
const ContentWrapper = styled.div `
  padding: 16px 18px 40px;
  background: ${brand.beige};

  @media ${from(Device.TabletLarge)} {
    padding: 16px 24px 40px;
  }
`;
const Distance = styled.span `
  display: inline-flex;
  align-items: center;
  background: ${brand.green};
  border-radius: 5px;
  color: ${brand.white};
  ${fonts.brandonGrotesque.bold}
  font-size: 18px;
  line-height: 1em;
  margin: 0 0 16px;
  padding: 8px;

  img {
    display: inline-block;
    height: 16px;
    margin-right: 8px;
    object-fit: contain;
    object-position: center;
    width: 16px;
  }
`;
const Name = styled.span `
  ${paragraphMedium}
  ${fonts.brandonGrotesque.bold}
  display: block;
  margin: 0 0 8px;
`;
const OpeningHours = styled.span `
  ${paragraphSmall}
`;
const BlockGrid = styled.div `
  display: grid;
  gap: 24px 16px;
  grid-template-columns: 1fr 1fr;
  margin: 0 0 32px;
`;
const Block = styled.div `
  ${paragraphSmall}
  margin: 0;

  &[data-layout='half'] {
    grid-column: span 1;
  }

  &[data-layout='full'] {
    grid-column: span 2;
  }
`;
const BlockTitle = styled.span `
  display: block;
  ${fonts.brandonGrotesque.bold}
`;
const BlockValue = styled.div ``;
const BlockValueLine = styled.span `
  display: block;
`;
const BlockLink = styled.a `
  display: flex;
  align-items: center;
  color: currentColor;
  ${fonts.brandonGrotesque.medium}
  margin-top: 4px;
  text-decoration: none;
  text-underline-position: under;

  svg {
    display: inline-block;
    height: 12px;
    margin-left: 8px;
    width: 6px;
  }

  &:focus,
  &:hover {
    text-decoration: underline;
  }
`;
const BlockLinkAlt = styled.a `
  display: flex;
  align-items: center;
  color: currentColor;
  text-decoration: none;
  text-underline-position: under;

  svg {
    display: inline-block;
    height: 22px;
    margin-right: 8px;
    width: 22px;
  }

  &:focus,
  &:hover {
    text-decoration: underline;
  }
`;
const BackWrapper = styled.div `
  padding: 16px 18px 40px;

  @media ${from(Device.TabletLarge)} {
    padding: 16px 24px 12px;
  }
`;
const BackButton = styled.button `
  ${BackButtonStyles}
`;
const BackIcon = styled.span `
  ${BackButtonIconStyles}
`;
const DetailPanelStyles = {
    Block,
    BlockGrid,
    BlockLink,
    BlockLinkAlt,
    BlockTitle,
    BlockValue,
    BlockValueLine,
    Container,
    ContentWrapper,
    Distance,
    Image,
    ImageWrapper,
    Name,
    OpeningHours,
    BackWrapper,
    BackButton,
    BackIcon,
};
export default DetailPanelStyles;
